var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M4.22 5.839v2.03a3.5 3.5 0 0 0 5.381 4.471l.942 1.187A5.001 5.001 0 0 1 2 9.997c0-1.733.881-3.26 2.22-4.158zm3.024-.094h3.006a.75.75 0 1 1 0 1.5H7.244v1.303c0 .133.115.241.257.241h3.462l1.526 1.947h.786a.725.725 0 0 1 0 1.449h-1.72l-1.526-1.947H7.5c-.99 0-1.793-.757-1.793-1.69V4.615h1.536v1.13zm-.756-1.763c-.848 0-1.498-.691-1.498-1.491C4.99 1.69 5.64 1 6.488 1c.849 0 1.544.69 1.544 1.49 0 .801-.695 1.492-1.544 1.492z" })
  );
});